module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1a"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01"
    }
  }, [_vm._v("Chapter 1: Bleeding Kansas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Missouri Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Defeat at Westport")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Retreat From Kansas City")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Trading Post and Marais des Cygnes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: “Charge With Me, for God’s Sake!”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: “Boot to Boot, Stirrup to Stirrup”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Confederates Break and Run")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Aftereffects")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Lieutenant Colonel Frederick Benteen’s After-Action Report")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0